module.exports = __webpack_public_path__ + "static/Trans-9-Clean-05616f81fb79a1864fea7d3dbe623693.svg";